import { Header } from '../HeaderItemsView/styles';

export const HeaderHistoryView = () => {
  return (
    <Header>
      <h3>Shoppingify History</h3>
    </Header>
  );
};
